/**
 * Shared formatting utilities for consistent display across the app
 */

/**
 * Format date to localized string
 */
export function formatDate(dateString: string, options?: Intl.DateTimeFormatOptions): string {
  const defaultOptions: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  };

  return new Date(dateString).toLocaleDateString('en-IN', options || defaultOptions);
}

/**
 * Format date with full details
 */
export function formatDateLong(dateString: string): string {
  return formatDate(dateString, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

/**
 * Format currency to Indian Rupees
 */
export function formatCurrency(amount: number, currency = 'INR'): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}

/**
 * Format currency with decimals
 */
export function formatCurrencyPrecise(amount: number, currency = 'INR'): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Format financial year string with "FY " prefix for consistent display
 * e.g. "2024-25" → "FY 2024-25", "FY 2024-25" → "FY 2024-25" (idempotent)
 */
export const formatFinancialYear = (fy: string): string => (fy.startsWith('FY ') ? fy : `FY ${fy}`);
